const mutations = {
    SET_RULES(state, payload) {
        state.rules = payload;
    },

    SET_RULE(state, payload) {
        state.rule = payload;
    },

    SET_FETCH_RULES_LOADING(state, payload) {
        state.fetchRulesLoading = payload;
    },

    SET_FETCH_RULE_LOADING(state, payload) {
        state.fetchRuleLoading = payload;
    },

    SET_CREATE_RULE_LOADING(state, payload) {
        state.createRuleLoading = payload;
    },

    SET_UPDATE_RULE_LOADING(state, payload) {
        state.updateRuleLoading = payload;
    },

    SET_DELETE_RULE_LOADING(state, payload) {
        state.deleteRuleLoading = payload;
    },
}

export default mutations;